// extracted by mini-css-extract-plugin
module.exports = {"passMessage":"index_passMessage__12Ea-","lateral":"index_lateral__2FCR2"};